const ThemeSwitcher = {
    light: {
        textColor: "#2F363F",
        backgroundColor: "#F9DDA4",
        border: "2px solid #F3B431",
        btnColor: "#DFAF2B",
    },
    dark: {
        textColor: "#F9DDA4",
        backgroundColor: "#2F363F",
        border: "2px dashed #F9DDA4",
        btnColor: "#586776",
    }
}

export default ThemeSwitcher;